import {NgbDateParserFormatter, NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';
import {Injectable} from '@angular/core';
import * as moment from 'moment';
import {AuthenticationService} from './authentication.service';

@Injectable()
export class NgbCountryDateParserFormatter extends NgbDateParserFormatter {

  constructor(private auth: AuthenticationService) {
    super();
  }

  readonly DT_FORMAT = this.auth.getDateFormat();

  parse(value: string): NgbDateStruct {
    if (value) {
      value = value.trim();
      let mdt = moment(value, this.DT_FORMAT);
    }
    return null;
  }

  format(date: NgbDateStruct): string {
    if (!date) {
      return '';
    }
    const mdt = moment([date.year, date.month - 1, date.day]);

    if (!mdt.isValid()) {
      return '';
    }
    return mdt.format(this.DT_FORMAT);
  }
}

